import { createFileRoute } from "@tanstack/react-router";
import IsChronicPainADisabilityPage from "@/pages/articles/IsChronicPainADisabilityPage";
export const Route = createFileRoute("/is-chronic-pain-a-disability")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Is Chronic Pain a Disability? | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Is chronic pain a disability? Learn about disability benefits, chronic pain management, and ketamine therapy options in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Is Chronic Pain a Disability? | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Is chronic pain a disability? Learn about disability benefits, chronic pain management, and ketamine therapy options in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/is-chronic-pain-a-disability",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/is-chronic-pain-a-disability",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <IsChronicPainADisabilityPage />;
}
